import { memo, useEffect, useRef } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { PackagePreviewCard } from 'entities/mine-package';
import { IPackage } from 'entities/mine-package/model';

interface PreviewSliderProps {
  selectedPackage: number;
  onPackageChange: (idx: number) => void;
  packages: IPackage[];
}

export const PackagesPreviewSlider = memo(({ selectedPackage, onPackageChange, packages }: PreviewSliderProps) => {
  const sliderRef = useRef<Splide>(null);

  useEffect(() => {
    if (!sliderRef.current) return;

    sliderRef.current.go(selectedPackage);
  }, [selectedPackage]);

  return (
    <Splide
      hasTrack={false}
      ref={sliderRef}
      onMoved={(_, idx) => onPackageChange(idx)}
      options={{
        flex: 1,
        gap: 16,
        pagination: false,
        type: 'slide',
        arrows: false,
      }}
      style={{ borderRadius: 12, overflow: 'hidden' }}
    >
      <SplideTrack>
        {packages.map((packageData) => (
          <SplideSlide key={packageData.contractId}>
            <PackagePreviewCard {...packageData} />
          </SplideSlide>
        ))}
      </SplideTrack>
    </Splide>
  );
});
